export default "__VITE_ASSET__LGI_M5zQ__"